import { Component, OnInit } from '@angular/core';
import { TracksServiceWeb } from '@asset-old/shared/services/analytics/tracks.service';
import { isNullOrUndefined } from '../../util/is-null-or-undefined.util';
import packageJson from 'package.json';
import { MensagensService } from '../../constantes/mensagens.service';
import { ActionsGA } from '../services/analytics/ga-objects';

@Component({
  selector: 'app-container-rodape',
  standalone: false,
  templateUrl: './container-rodape.component.html',
  styleUrls: ['./container-rodape.component.css'],
})
export class ContainerRodapeComponent implements OnInit {
  appVersion: string;
  texto: string;
  textoParaRenderizar: string[];
  endereco: string;
  ano: string;
  linkPoliticaPrivacidade: string;
  actionFooter: string = ActionsGA.FOOTER;

  constructor(private analytics: TracksServiceWeb) {}

  ngOnInit() {
    this.preencherConstantesDaPagina();
    this.formatarTexto();
    this.appVersion = packageJson.version;
  }

  /**
   * Identifica quebras de linha no parágrafo do rodapé e
   * inicializa array de strings para que essas quebras sejam
   * refletidas no HTML.
   */
  private formatarTexto(): void {
    if (!isNullOrUndefined(this.texto)) {
      this.textoParaRenderizar = this.texto.split('\n');
    }
  }

  /**
   * Preenche textos de endereço e ano de direitos autorais
   * basedo nos retornos do serviço de leitura do arquivo JSON
   * de constantes.
   */
  private preencherConstantesDaPagina(): void {
    this.endereco = MensagensService.mensagens.compartilhado.rodape.endereco;
    this.linkPoliticaPrivacidade =
      MensagensService.mensagens.compartilhado.rodape.linkPoliticaPrivacidade;
    this.ano =
      MensagensService.mensagens.compartilhado.rodape.anoDireitosAutorais;
    this.texto = MensagensService.mensagens.compartilhado.rodape.textoRodape;
  }

  trackGA(label: string) {
    //this.analytics.trackEvent({ category: CategoriesGA.CLIQUE, action: this.actionFooter, label: label });
    this.analytics.tracks.newEvent('click', 'footer', label);
  }
}
